import type { SupplierOrderSortField } from './sections/SupplierOrdersPanel';

export const SUPPLIER_ORDER_FINANCIAL_SORT_FIELDS: SupplierOrderSortField[] = [
  'totalAmount',
  'totalAmountPLN',
];

export function canUseSupplierOrderFinancialSortFields(
  canViewSupplierOrderPurchasePrices: boolean,
): boolean {
  return canViewSupplierOrderPurchasePrices;
}

export function shouldResetSupplierOrderFinancialSort(
  canViewSupplierOrderPurchasePrices: boolean,
  sortBy: SupplierOrderSortField,
): boolean {
  return !canUseSupplierOrderFinancialSortFields(canViewSupplierOrderPurchasePrices)
    && SUPPLIER_ORDER_FINANCIAL_SORT_FIELDS.includes(sortBy);
}
